import { useQuery } from "@tanstack/react-query";
import { getDeedSuggestions } from "../services/api";
import { useAuth } from "../components/Auth/AuthContext";

const useDeedSuggestions = () => {
  const { currentUser } = useAuth();

  const { data } = useQuery({
    queryKey: ["deed-suggestions"],
    queryFn: async () => {
      const response = await getDeedSuggestions();
      return response.data;
    },
    enabled: !!currentUser,
    staleTime: 60_000,
  });

  return {
    deedOptions: data?.descriptions ?? [],
    bucketOptions: data?.buckets ?? [],
  };
};

export default useDeedSuggestions;
